// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#253977', // Your brand's primary color
            light: '#475b99',
            dark: '#031755',
            contrastText: '#fff', // Ideal text color for contrast
        },
        secondary: {
            main: '#d47b27', // Your brand's secondary color
            light: '#f69d49',
            dark: '#b25905',
            contrastText: '#fff',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    // Apply styles to the button's root element
                    borderRadius: '8px',
                    textTransform: 'none', // Prevent uppercase text
                },
                containedPrimary: {
                    // Styles for contained buttons with primary color
                    backgroundColor: '#253977',
                    '&:hover': {
                        backgroundColor: '#475b99',
                    },
                },
                outlinedPrimary: {
                    // Styles for outlined buttons with primary color
                    borderColor: '#007bff',
                    color: '#007bff',
                    '&:hover': {
                        backgroundColor: '#b3d4ff',
                        borderColor: '#0056b3',
                    },
                },
            },
        },
    },
});

export default theme;